module.exports = "query GetStorefront($slug: String!) {\n  user(storefrontSlug: $slug) {\n    ...MinimalSponsorFragment\n  }\n}\n"